<template>
  <div class="footer-container" v-if="config">
    <div class="icons">
      <img src="../assets/images/beian.png" style="width:50px; height:60px;">
    </div>
    <div class="body">
      <div class="text">{{ config.site_name }}</div>
      <div class="text"> <span v-html="config.beian"></span> &nbsp;&nbsp;&nbsp;&nbsp;地址：{{ config.address }}&nbsp;&nbsp;&nbsp;&nbsp;电话：{{ config.phone }}</div>
      <div class="text" v-html="config.other_info"></div>
      <div class="text" v-html="config.tech"></div>
    </div>
    <div class="none"></div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Footer",
  computed: {
    ...mapState(['config'])
  }
}
</script>

<style scoped>
.footer-container{
  height: 12rem;
  border-top: 5px solid #FFC400;
  background-color: #BC0000;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-end;
  justify-content: center;
  align-items: center;
}
.icons {
  width: 200px;
  display: flex;
  justify-content: flex-end;
}
.icons .el-image{
  margin-left: 5px;
}
.body {
  width: 800px;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
}
.body a {
  color: #fff!important;
}
.none {
  width: 200px;
}
</style>